export enum BillingWeekDay {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export namespace BillingWeekDay {
  export const translateType = (day: BillingWeekDay): string => {
    switch (day) {
      case BillingWeekDay.Sunday:
        return "Domingo";
      case BillingWeekDay.Monday:
        return "Segunda-feira";
      case BillingWeekDay.Tuesday:
        return "Terça-feira";
      case BillingWeekDay.Wednesday:
        return "Quarta-feira";
      case BillingWeekDay.Thursday:
        return "Quinta-feira";
      case BillingWeekDay.Friday:
        return "Sexta-feira";
      case BillingWeekDay.Saturday:
        return "Sábado";
      default:
        return "";
    }
  };

  export const billingWeekDayChoices: Array<{ id: number; name: string }> = Object.values(BillingWeekDay)
    .filter(value => typeof value === "number")
    .map((day) => ({
      id: day as number,
      name: BillingWeekDay.translateType(day as BillingWeekDay),
    }));
}